<template>
    <div>
        <div v-for="(line, index) in lines">
            <div class="form-group mt-3">
                <label :for="fieldName + '-line-' + index">Zeile {{ index + 1 }}</label>
                <div class="input-group">
                    <input type="text" :name="fieldName + '['+index+']'" class="form-control input-with-addon"
                           :id="fieldName + '-line-' + index"
                           v-model="lines[index].value" aria-label="Adresszusatz" :aria-describedby="index + '-button'"
                           :placeholder="'Adresszeile ' + (index + 1)" v-on:keyup="sendToParent(index)">
                    <div class="input-group-append" tabindex="-1">
                        <span class="btn btn-outline-secondary" :id="index + '-button'"
                                @click="removeLine(index)" tabindex="-1"><i class="fas fa-times"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-right">
                <button class="btn btn-link btn-sm address-add-btn" type="button" v-on:click="addAddressLine">
                    <i class="fas fa-plus"></i> Adresszeile hinzufügen
                </button>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "AddressLine",
        props: {
            number: {
                type: Number,
                required: false,
                default: 0
            },
            givenLines: {
                type: Array,
                required: true
            },
            fieldName: {
                type: String,
                required: false,
                default: "address[additional]"
            }
        },
        data() {
            return {
                id: "",
                value: "",
                placeholder: "zusätzliche Adresszeile",
                lines: []
            }
        },
        computed: {
            addressLines(){
                let values = [];
                this.lines.each(function(entry, index){
                    values.push(entry.value);
                });
                return values;
            }
        },
        methods: {
            addAddressLine() {
                this.lines.push({
                    placeholder: "Ich bin ein Platzhalter",
                    value: "",
                    id: this.lines.length
                });
            },
            removeLine(index) {
                this.lines.splice(index, 1);
                this.$emit('removeAddressLine', index);
            },
            sendToParent(index){
                this.$emit('newAddressLine', this.lines[index]);
            }
        },
        watch:{
            givenLines: {
                handler(newValue, oldValue){
                    this.lines = this.givenLines;
                }
            },
            deep: false
        },
        mounted() {
            this.lines = this.givenLines;
        }
    }
</script>

<style scoped type="text/scss">
    .btn-outline-secondary {
        border-color: rgb(140, 140, 140);
        border-left: none;
    }

    .input-with-addon {
        border-right: none;
    }

    .address-add-btn {
        color: black;
    }
</style>
